export default "__VITE_ASSET__d53d4a81__"